// extracted by mini-css-extract-plugin
export default {"root":"JTFeA6Uspgs9VedDzIsw","add-section":"TVb36CJZb4t0wEhNfk1M","addSection":"TVb36CJZb4t0wEhNfk1M","divider":"k8aPFeBLAQYSyC8Sg4PJ"};